import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import UserForm from '../components/forms/user-form';

const UsersFormRoute: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const id = searchParams.get('id')
  return (
    <>
      <PageHeader
        title="فرم کاربر"
        style={{ padding: " 16px 0" }}
        onBack={() => navigate(-1)}
        />
      <Card >
        <UserForm id={id} />
      </Card>
    </>
  );
}

export default UsersFormRoute;
